import React, { Component } from 'react';
import './calculator.scss';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as budgetActions from '../../actions/budgetActions';
import * as mandatoriesActions from '../../actions/mandatoriesActions';
import BudgetContainer from './BudgetContainer';
import BudgetLink from './BudgetLink';
import EstimateProgress from '../common/EstimateProgress'
import PropTypes from 'prop-types';

class CalculatorPage extends Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			loading: true,
			selectedBudget: null,
		};
		this.props.actions.loadBudgetContainers();
		this.budgetLinks = this.budgetLinks.bind(this);
		this.budgetSelectionHandler = this.budgetSelectionHandler.bind(this);
	}

	budgetLinks(props) {
		const current = this.props.match.params.id === undefined ? null : Number(this.props.match.params.id)
		return this.props.budgets.map((budget) => {
			let selected = false;
			if(current === budget.id) {
				selected = true;
			}
			return (<BudgetLink onClick={this.budgetSelectionHandler} budget={budget} key={budget.id}
				selectedBudget={this.state.selectedBudget} />)

		})
	}


	componentDidUpdate(prevProps, prevState) {

		if(this.props.budgets && this.props.budgets.length > 0) {
			const current = this.props.match.params.id === undefined ? null : Number(this.props.match.params.id)
			this.props.budgets.map((budget) => {
				if(current === budget.id) {
					// If we're changing the selected budget...
					if(prevState.selectedBudget !== budget.id) {
						// Update the instance of the budget in state... just a shorthand for the url params
						this.setState({selectedBudget: budget.id});
						// Undo the progress through the line itmes...
						this.props.mandatoriesActions.moveToLineItem(0);
					}
				}
			})

		}
	}

	budgetSelectionHandler(id) {
		//this.setState({selectedBudget: id})
	}


  render() {
    return (
      <div className="calculator-page">
        <header className="calculator-header">

          <h1>Budget Calculator</h1>
					<h6>This simple online tool allows you to create a plan that meets
					your vision – and your budget. Our simple to use interface allows
					you to easily modify and prioritize project goals based on instant
					budgetary results. Please allow one of our BSI representative to
					walk you through the Budget Calculator.</h6>

        </header>

				<nav>
					<ul className="calculator-main-nav">
						{this.props.budgets && this.budgetLinks()}
					</ul>
				</nav>

				<section>
					{this.state.selectedBudget !== null &&
					<BudgetContainer selectedBudget={this.state.selectedBudget} budgets={this.props.budgets} /> }
				</section>
				{this.state.selectedBudget !== null && <EstimateProgress id={Number(this.props.match.params.id)} />}
      </div>

    );
  }
}

CalculatorPage.propTypes = {
	match : PropTypes.object
}

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		actions: bindActionCreators(budgetActions, dispatch),
		mandatoriesActions: bindActionCreators(mandatoriesActions, dispatch)
	};
}

const mapStateToProps = (state, ownProps) => {

	// let mostFavoriteIds = state.user.FavoriteLocations.filter(loc => loc.IsMostFavorite).map(mostFav => mostFav.RestaurantId);
	// let immutableRestaurants = [...state.restaurants].map((restaurant) => {
	// 	return Object.assign({}, restaurant, { IsMostFavorite: mostFavoriteIds.indexOf(restaurant.Id) > -1 });
	// });

	// immutableRestaurants.sort((rA, rB) => {
	// 	let nameA = rA.Title.toUpperCase(); // ignore upper and lowercase
	// 	let nameB = rB.Title.toUpperCase(); // ignore upper and lowercase
	// 	if (rA.IsMostFavorite ^ rB.IsMostFavorite) {
	// 		return rA.IsMostFavorite ? -1 : 1; // mostFavoriteRestaurant should be closer to the beginning of the list
	// 	} else {
	// 		if (nameA < nameB) return -1;
	// 		if (nameA > nameB) return 1;
	// 		return 0;
	// 	}
	// });

	return {
		budgets: state.budgets
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(CalculatorPage);



// WEBPACK FOOTER //
// ./src/components/calculator/CalculatorPage.js